<template>
    <div>
        <div class="max-w-[1088px] mx-auto h-full">
            <slot />
        </div>
    </div>
</template>
